import { render, staticRenderFns } from "./DisplayForm.vue?vue&type=template&id=2db4cd35&scoped=true"
import script from "./DisplayForm.vue?vue&type=script&lang=js"
export * from "./DisplayForm.vue?vue&type=script&lang=js"
import style0 from "./DisplayForm.vue?vue&type=style&index=0&id=2db4cd35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db4cd35",
  null
  
)

export default component.exports